/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentTemplateDto } from '../../models/create-document-template-dto';
import { DocumentTemplateDto } from '../../models/document-template-dto';

export interface AdminDocumentTemplateControllerUpdateDocument$Params {
  id: string;
      body: CreateDocumentTemplateDto
}

export function adminDocumentTemplateControllerUpdateDocument(http: HttpClient, rootUrl: string, params: AdminDocumentTemplateControllerUpdateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentTemplateControllerUpdateDocument.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentTemplateDto>;
    })
  );
}

adminDocumentTemplateControllerUpdateDocument.PATH = '/api/document-template-admin/{id}';
